<template>
  <div>
    <InputNumber
        v-model="quantity"
        label="Quantidade Pague"
        name="quantity"
        :errors="errors"
    />
    <InputNumber
        v-model="quantity2"
        label="Quantidade Leve"
        name="quantity2"
        :errors="errors"
    />
  </div>
</template>
<script>
import InputMoney from "../inputs/InputMoney.vue";
import InputNumber from "../inputs/InputNumber.vue";

export default {
  name: "LmpmCategoria",
  components: {InputNumber, InputMoney},
  data() {
    return {
      errors: [],
      quantity: null,
      quantity2: null,
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/carrefour/rules/LmpmCategoria.vue